// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Col } from "@components";

type OwnProps = $Exact<{
  title: string,
  text: string,
  onCancel: () => void,
  onSubmit: (form: Object) => void,
  ...PropsFromLocalize,
}>;

const BulkRegistrationEmailsModal = (props: OwnProps) => {
  return (
    <Modal className="modal-normal">
      <ModalHeader toggle={props.onCancel} className="d-flex justify-content-between">
        {props.title}
      </ModalHeader>
      <ModalBody>
        <Col sm={{ size: 10, offset: 1 }}>
          {props.text}
          <p />
          {props.t("SEND_BULK_EMAILS_TEXT2")}
        </Col>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-end">
        <Button color="secondary" onClick={props.onCancel}>
          {props.t("CANCEL")}
        </Button>
        <Button materialIcon="email" onClick={props.onSubmit}>
          {props.t("SEND")}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default localize()(BulkRegistrationEmailsModal);
